import lazy from '../../utils/lazy';
import { ContactUsUrl } from '../../constants/url';

const contactUsRoutes: RouteInfo[] = [
  {
    path: ContactUsUrl,
    exact: true,
    component: lazy(() => import('./pages/ContactUs'))
  }
];

export default contactUsRoutes;
